export default "__VITE_ASSET__dd42c0d0__"